export const translations = {
  en: {
    dir: "ltr",
    appName: "Saudi Complaint Portal",
    tagline: "File formal complaints to GACA, CST & TGA — assisted by AI.",
    chooseLanguage: "Choose your language",
    continue: "Continue",
    login: "Sign in",
    signup: "Sign up",
    logout: "Sign out",
    myComplaints: "My complaints",
    guestMode: "Continue as guest",
    step: "Step",
    of: "of",
    // categories
    chooseCategory: "What is your complaint about?",
    categorySub: "Select the sector — we'll route your complaint to the right authority.",
    catAir: "Air Carrier",
    catAirDesc: "Flight delays, cancellations, denied boarding, baggage — filed to GACA.",
    catPhone: "Telecom / Phone Company",
    catPhoneDesc: "Billing, coverage, service quality, contracts — filed to CST.",
    catPackage: "Package Delivery",
    catPackageDesc: "Lost, damaged, or late parcels — filed to TGA.",
    // composer
    describeIssue: "Describe your issue",
    describeHelper: "Write freely. Include dates, reference numbers, and what happened. Our AI will structure it into a formal complaint.",
    refineWithAI: "Refine with AI",
    refining: "Drafting…",
    aiDraft: "AI-drafted formal complaint",
    editDraft: "You can edit the draft below before submitting.",
    back: "Back",
    next: "Next",
    reset: "Start over",
    // submit page
    submitTitle: "Submit your complaint",
    submitSub: "Follow these steps to file it on the official portal.",
    copyText: "Copy complaint text",
    copied: "Copied to clipboard",
    openPortal: "Open official portal",
    yourDraft: "Your drafted complaint",
    saveToAccount: "Save to my account",
    saved: "Complaint saved",
    // policies
    policiesTitle: "Relevant policies & your rights",
    policiesSub: "Regulations that apply to your case, plus a tailored explanation.",
    keyRegulations: "Key regulations",
    tailoredExplanation: "Tailored explanation",
    generating: "Generating explanation…",
    finish: "Finish",
    // ask policies chat
    askAboutPolicies: "Ask about these policies",
    askHelper: "Get answers based only on the relevant Saudi authority's regulations.",
    askPlaceholder: "e.g. How long can an airline delay my flight before I get compensation?",
    askSend: "Ask",
    asking: "Thinking…",
    askEmptyState: "Ask any question about the policies above.",
    askDisclaimer: "Answers reference only the selected Saudi authority. Not legal advice.",
    clearChat: "Clear chat",
    you: "You",
    assistant: "Assistant",
    // auth
    email: "Email",
    password: "Password",
    name: "Full name",
    haveAccount: "Already have an account?",
    noAccount: "New here?",
    // errors
    errorGeneric: "Something went wrong. Please try again.",
    emptyText: "Please describe your issue first.",
    // attachments
    attachEvidence: "Attach evidence",
    attachOptional: "Optional",
    attachHelper: "Add photos, PDFs, receipts, or boarding passes (max 5 files · 10 MB each).",
    addFile: "Add file",
    remove: "Remove",
    fileTooLarge: "File exceeds 10 MB",
    fileTypeBad: "Only images (JPG, PNG, WEBP, GIF) and PDF are allowed",
    maxFilesReached: "Maximum 5 files allowed",
    uploading: "Uploading…",
    attachments: "Attachments",
    attachedFiles: "Attached files",
  },
  ar: {
    dir: "rtl",
    appName: "بوابة الشكاوى السعودية",
    tagline: "قدّم شكاوى رسمية إلى الطيران المدني (GACA) والاتصالات (CST) والنقل (TGA) بمساعدة الذكاء الاصطناعي.",
    chooseLanguage: "اختر لغتك",
    continue: "متابعة",
    login: "تسجيل الدخول",
    signup: "إنشاء حساب",
    logout: "تسجيل الخروج",
    myComplaints: "شكاواي",
    guestMode: "المتابعة كضيف",
    step: "الخطوة",
    of: "من",
    chooseCategory: "ما موضوع شكواك؟",
    categorySub: "اختر القطاع — سنوجّه شكواك إلى الجهة المختصة.",
    catAir: "شركة طيران",
    catAirDesc: "تأخر الرحلات، الإلغاء، رفض الصعود، الأمتعة — تُرفع إلى الهيئة العامة للطيران المدني.",
    catPhone: "شركة اتصالات",
    catPhoneDesc: "الفوترة، التغطية، جودة الخدمة، العقود — تُرفع إلى هيئة الاتصالات.",
    catPackage: "توصيل الطرود",
    catPackageDesc: "طرود مفقودة أو تالفة أو متأخرة — تُرفع إلى الهيئة العامة للنقل.",
    describeIssue: "اشرح مشكلتك",
    describeHelper: "اكتب بحرية. اذكر التواريخ وأرقام المرجع وما حدث. سيقوم الذكاء الاصطناعي بصياغتها كشكوى رسمية.",
    refineWithAI: "صياغة بالذكاء الاصطناعي",
    refining: "جارٍ الصياغة…",
    aiDraft: "الشكوى الرسمية المصاغة",
    editDraft: "يمكنك تعديل النص قبل تقديمه.",
    back: "رجوع",
    next: "التالي",
    reset: "البدء من جديد",
    submitTitle: "قدّم شكواك",
    submitSub: "اتبع الخطوات لتقديمها عبر البوابة الرسمية.",
    copyText: "نسخ نص الشكوى",
    copied: "تم النسخ",
    openPortal: "فتح البوابة الرسمية",
    yourDraft: "شكواك المصاغة",
    saveToAccount: "حفظ في حسابي",
    saved: "تم حفظ الشكوى",
    policiesTitle: "الأنظمة ذات الصلة وحقوقك",
    policiesSub: "الأنظمة المطبَّقة على حالتك مع شرح مخصص.",
    keyRegulations: "أهم الأنظمة",
    tailoredExplanation: "شرح مخصص لحالتك",
    generating: "جارٍ توليد الشرح…",
    finish: "إنهاء",
    askAboutPolicies: "اسأل عن هذه الأنظمة",
    askHelper: "احصل على إجابات مستندة فقط إلى أنظمة الجهة السعودية المختصة.",
    askPlaceholder: "مثال: كم مدة التأخير المسموح بها قبل استحقاق التعويض؟",
    askSend: "اسأل",
    asking: "يفكّر…",
    askEmptyState: "اسأل أي سؤال حول الأنظمة أعلاه.",
    askDisclaimer: "الإجابات تستند فقط إلى الجهة السعودية المختارة. ليست استشارة قانونية.",
    clearChat: "مسح المحادثة",
    you: "أنت",
    assistant: "المساعد",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    haveAccount: "لديك حساب؟",
    noAccount: "مستخدم جديد؟",
    errorGeneric: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    emptyText: "يرجى وصف مشكلتك أولاً.",
    attachEvidence: "إرفاق أدلة",
    attachOptional: "اختياري",
    attachHelper: "أضف صورًا أو ملفات PDF أو إيصالات أو بطاقات صعود (حد أقصى 5 ملفات · 10 ميجابايت لكل ملف).",
    addFile: "إضافة ملف",
    remove: "إزالة",
    fileTooLarge: "حجم الملف يتجاوز 10 ميجابايت",
    fileTypeBad: "يُسمح فقط بالصور (JPG, PNG, WEBP, GIF) وملفات PDF",
    maxFilesReached: "الحد الأقصى 5 ملفات",
    uploading: "جارٍ الرفع…",
    attachments: "المرفقات",
    attachedFiles: "الملفات المرفقة",
  },
};

export const t = (lang, key) => translations[lang]?.[key] ?? translations.en[key] ?? key;
